import { render, staticRenderFns } from "./UserConfig.vue?vue&type=template&id=e197199c&scoped=true"
import script from "./UserConfig.vue?vue&type=script&lang=js"
export * from "./UserConfig.vue?vue&type=script&lang=js"
import style0 from "./UserConfig.vue?vue&type=style&index=0&id=e197199c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e197199c",
  null
  
)

export default component.exports